// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qLKCL","fullView":"styles_fullView__1qKKF"};